var render = function render(){var _vm=this,_c=_vm._self._c;return _c('land-owner-selection',{attrs:{"data-test-id":"land-owner-type","land-owner":_vm.landOwner,"disable-beneficiary-option":"","contractor-name":_vm.contractorName,"third-party-note":_vm.$t('buildingVocationRentalThirdPartyNote', { contractorName: _vm.contractorName })}})
}
var staticRenderFns = []

export { render, staticRenderFns }